import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import SymbolSearchPopup from "./SymbolSearchPopup";


export default function SetPage(){

    const [cookies] = useCookies(['uuid']);
    const [signals, setSignals] = useState([]);

    // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
    const[uid,setUID] = useState(0);
    const[nickname,setNickname] = useState('');
    const[extention_possible,setExtentionPossible] = useState(0);

    const [symbolList, setSymbolList] = useState([]);

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const [signalText, setSignalText] = useState("UT Signals");

    useEffect(() => {
      if (!cookies.uuid) {
        alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
        window.location.href = `/LoginAts`;
        return;
      } else {
        const uuid = cookies.uuid;
        fetchUserInfo(uuid);
      }
    }, []);

    useEffect(() => {
      console.log('클라이언트 uuid checking');
    }, [cookies.uuid]);
  
    const fetchUserInfo = (uuid) => {
      fetch(`/SetPage/user?uuid=${uuid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          const user = data[0];
          setUID(user.uid);
          setNickname(user.nickname);
          setExtentionPossible(user.extention_possible);
          const possible = user.wz_possible;
          const nickname = user.nickname;
        });
    };
    
    
    const[symbol,setSymbol] = useState('default');

    //////////////////////////////////////////////////////////

    const[sensitivity,setSensitivity] = useState(2);
    const[atr_period,setAtrPeriod] = useState(2);
    const[entry_length,setEntryLength] = useState(20);
    const[exit_length,setExitLength] = useState(10);
    const[mix_candle,setMixCandle] = useState('15m');
    const[candle_type,setCandleType] = useState('haikin');

    //////////////////////////////////////////////////////////

    const[sensitivityValid, setSensitivityValid] = useState(true);
    const[atrperiodValid, setAtrperiodValid] = useState(true);

    const[entrylengthValid, setEntrylengthValid] = useState(true);
    const[exitlengthValid, setExitlengthValid] = useState(true);

    const[notAllow, setNotAllow] = useState(true);

    const[search,setSearch] = useState(false);

    // 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //
    const handleMixCandle = (e) => {
      setMixCandle(e.target.value);
        };
    
    const handleCandleType = (e) => {
      setCandleType(e.target.value);
        };

    const handleSensitivity = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivity(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityValid(true);
          } 
        else {
          setSensitivityValid(false);
          }
        };
    
    const handleAtrperiod = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriod(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodValid(true);
          } 
        else {
          setAtrperiodValid(false);
          }
        };
    
    const handleEntrylength = (e) => {
      const newEntrylength = e.target.value.trim();
      setEntryLength(newEntrylength);
        const regex = 
        /^\d*$/;
        if (regex.test(newEntrylength)) {
          setEntrylengthValid(true);
          } 
        else {
          setEntrylengthValid(false);
          }
        };
    
    const handleExitlength = (e) => {
      const newExitlength = e.target.value.trim();
      setExitLength(newExitlength);
        const regex = 
        /^\d*$/;
        if (regex.test(newExitlength)) {
          setExitlengthValid(true);
          } 
        else {
          setExitlengthValid(false);
          }
        };
    
    const handleAddSymbol = (symbol) => {
      const confirmed = window.confirm(`${symbol}을 리스트에 추가할까요?`);
      if (confirmed) {
      fetch(`/add_user_symbols?uid=${uid}&symbol=${symbol}`)
      .then(res => res.json())
      .then(data => setSymbolList(data.signal))
      .catch(err => console.error(err));
      }
    };

    const deleteSymbol = (symbol) => {
      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      const confirmed = window.confirm(`${symbol}을 리스트에서 삭제할까요?`);
      if (confirmed) {
      fetch(`/delete_user_symbols?uid=${uid}&symbol=${symbol}`)
      .then(res => res.json())
      .then(data => setSymbolList(data.signal))
      .catch(err => console.error(err));
      setSymbol('default')
      setSignals([]);
      }
    };

    const handleClosePopup = () => {
      setIsPopupOpen(false);
    };

    /////////////////////////////////////////////////////////////////
    
    useEffect(() => {

      if(sensitivityValid && atrperiodValid && entrylengthValid && exitlengthValid) {
        setNotAllow(false);
        return;
      }
      setNotAllow(true);
    }, [sensitivityValid, atrperiodValid, entrylengthValid, exitlengthValid]);

    useEffect(() => {
      fetch(`/get_user_symbols?uid=${uid}`)
      .then(res => res.json())
      .then(data => setSymbolList(data.signal))
      .catch(err => console.error(err));
    },[symbol,signalText,uid]);

    const onSelectSymbol = (symbol) => {
      setSignals([]);
      const str = symbol;
      setSensitivity(sensitivity);
      setAtrPeriod(atr_period);
      setEntryLength(entry_length);
      setExitLength(exit_length);
      setMixCandle(mix_candle);
      setCandleType(candle_type);
    }

    const onClick_UT_Search = async (symbol) => {
      const kind_of_signal = "all";

      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      
      setSignals([]);
      setSignalText('UT Signals')

      const payload = {
        uid,
        symbol,
        mix_candle,
        sensitivity,
        atr_period,
        entry_length,
        exit_length,
        kind_of_signal,
        candle_type
      };
      //  
      try {
        const response = await fetch('/ut_signals', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const data = await response.json();
        setSignals(data.signal);
    
        // 예: 결과 처리 함수가 있다면 여기에서 호출
        // handleSearchResult(data);
    
      } catch (error) {
        console.error('요청 중 오류 발생:', error);
      }
    };
  
    const onClick_TURTLE_Search = async (symbol) => {
      const kind_of_signal = "all";

      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      
      setSignals([]);
      setSignalText('TURTLE Signals')

      const payload = {
        uid,
        symbol,
        mix_candle,
        sensitivity,
        atr_period,
        entry_length,
        exit_length,
        kind_of_signal,
        candle_type
      };
    
      try {
        const response = await fetch('/turtle_signals', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const data = await response.json();
        setSignals(data.signal);
    
        // 예: 결과 처리 함수가 있다면 여기에서 호출
        // handleSearchResult(data);
    
      } catch (error) {
        console.error('요청 중 오류 발생:', error);
      }
    };

    return (
        <div className="page_sp_leverage_samaria">
          <div className="title_top_sp">
          <div></div>
            <div className="titleWrap_sp_lever">
            Auto trade system (RV version) - UT/TURTLE signals</div>
            <div className="inputTitle_uid_lever">
                <span>UID : {uid}</span>
                <span>{nickname}님 환영합니다</span>
            </div>
          </div>

          <div className="line_top"></div>

            <div className="container_samaria">
              <div className="column_leverage">
              <div className="button_benefit_leverage">
                <select className="usdt_select_lv_samaria" 
                  value = {symbol} 
                  onChange={(e) => {setSymbol(e.target.value); 
                                    onSelectSymbol(e.target.value);}}>
                  <option value="">symbol select</option>
                  {symbolList.map((sym, idx) => (
                      <option key={idx} value={sym}>{sym}</option>
                  ))}
                </select>
              <button onClick={() => setIsPopupOpen(true)} disabled={!symbol} className="button_benefit_c_ut">
                추 가
              </button>
              <button onClick={() => deleteSymbol(symbol)} disabled={!symbol} className="button_benefit_c_ut">
                삭 제
              </button>
              </div>
              {/* 팝업은 여기서 조건부 렌더링 */}
              <div>
                <SymbolSearchPopup
                  isOpen={isPopupOpen}
                  onAdd={handleAddSymbol}
                  onClose={handleClosePopup}
                  />
              </div>
              <div className="contentWrap_sp">
              <div className="line"></div>
              <div className="center_text_lever">UT signal setting</div>
                <div className="leverage_container">
                  <div className="leverage_item">Sensitivity</div>
                  <input 
                  type="number"
                  className="leverage_input_basic"
                  value={sensitivity}
                  onChange={handleSensitivity} />
                  <div className="leverage_item">ATR_period</div>
                  <input 
                  type="number" 
                  className="leverage_input_basic"
                  value={atr_period}
                  onChange={handleAtrperiod} />
                </div>
              <div className="line"></div>
              <div className="center_text_lever">TURTLE signal setting</div>
                <div className="leverage_container">
                  <div className="leverage_item">Entry length</div>
                  <input 
                  type="number" 
                  className="leverage_input_basic"
                  value={entry_length}
                  onChange={handleEntrylength} />
                  <div className="leverage_item">Exit length</div>
                  <input 
                  type="number" 
                  className="leverage_input_basic"
                  value={exit_length}
                  onChange={handleExitlength} />
                </div>
                <div className="line"></div>
                <div className="leverage_container">
                  <div class="leverage_item">기준 캔들</div>
                  <select className="select_samaria" value={candle_type} onChange={handleCandleType}>
                    <option value="haikin">하이킨아시</option>
                    <option value="normal">일반봉</option>
                  </select>
                  <div className="leverage_item">기준 시간봉</div>
                    <select className="select_samaria" value={mix_candle} onChange={handleMixCandle}>
                      <option value="5m">5 분봉</option>
                      <option value="15m">15 분봉</option>
                      <option value="30m">30 분봉</option>
                      <option value="1h">1 시간봉</option>
                      <option value="4h">4 시간봉</option>
                    </select>
                </div>
               </div>
                <div className="leverage_container">
                <div className="button_benefit_samaria">
                  <button onClick={() => onClick_UT_Search(symbol)} disabled={!symbol} style={{marginRight:'100px'}}className="button_benefit_c_ut">
                    UT 신호 조회하기
                  </button>
                  <button onClick={() => onClick_TURTLE_Search(symbol)} disabled={!symbol} className="button_benefit_c_ut">
                    TURTLE 신호 조회하기
                  </button>
                </div>
                </div>
              </div>
            </div>
            {signals && signals.length > 0 && (
              <div className="signal_table_wrap">
                <div className="center_text_lever_samaria">📊 {signalText} 결과 ({symbol}) </div>
                <table className="signal_table">
                  <thead>
                    <tr>
                      <th>Candle_count</th>
                      <th>Time</th>
                      <th>Signal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {signals.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.index}</td>
                        <td>{item.time}</td>
                        <td style={{ color: (item.signal === 'buy' || item.signal === 'buy exit') ? '#00ff90' : '#ff7070' }}>
                          {item.signal.toUpperCase()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
      </div>
    );
}